import { useTranslation } from "react-i18next";
import MainLayouts from "../layouts/MainLayouts";
import NewsListSection from "../components/news/NewsListSection";
import FilterDropdown from "../custom-components/filters/FilterDropdown";
import SimplePageHeader from "../components/SimplePageHeader";

export default function NewsListPage() {
    const { t } = useTranslation();

    return (
        <MainLayouts pageTitle={t("news.pageTitle")}>
            <div className="md:hidden w-full mx-auto mt-10 mb-[50px]">
            {/*    <h1 className="font-geologica text-2xl font-medium uppercase text-primary-400 mb-5">
                    {t("news.pageTitle")}
                </h1>
                <FilterDropdown /> */}
            </div>

            <div className="hidden md:block">
                <SimplePageHeader
                    title={t("news.pageTitle")}
                    rightSlot={
                        <div className="flex items-center gap-[24px]">
                        {/*    <span className="text-base text-text-300">{t("news.filters.sortBy")}</span>
                            <FilterDropdown /> */}
                        </div>
                    }
                />
            </div>

            <NewsListSection />
        </MainLayouts>
    );
}